<template>
    <div class="header-title">
        <div class="container">
            <h1 class="animate fadeInDown text-center fw-bold">{{ $route.name }}</h1>
            <span class="text-white d-flex justify-content-center">
                <router-link class="link" to='/'><i class="bi bi-house px-2"></i>Acasă</router-link> <span
                    class="text-white px-2">/</span>
                <router-link class="link" :to=$route.path>{{ $route.name }}</router-link>
            </span>
        </div>
    </div>
</template>

<style scoped>
.header-title {
    position: relative;
    height: 350px;
    color: white;
    display: flex;
    align-items: center;
    background-image: var(--shadow-header), url(../assets/img/ro2_blur.jpg);
    background-size: cover; /* Asigură că imaginea acoperă tot ecranul */
    background-position: center; /* Centrează imaginea */
    background-repeat: no-repeat;
}

.header-title .link {
    color: white;
    text-decoration: none;
}

.header-title a.router-link-exact-active {
    color: white;
}
</style>